import { COMPANY } from "../data/company";
import { LegalLayout } from "../components/LegalLayout";

export default function Retur() {
  return (
    <LegalLayout
      title="Politica de retur"
      subtitle="Conform OUG 34/2014, ai 14 zile la dispoziție pentru a returna produsele, fără a justifica motivele."
      lastUpdated="Februarie 2026"
    >
      <h2 className="font-heading text-xl font-bold text-slate-900">1. Dreptul de retragere</h2>
      <p>
        În conformitate cu OUG 34/2014, ai dreptul de a te retrage din contract
        în termen de <strong>14 zile calendaristice</strong>, fără a fi nevoie
        să justifici motivele și fără a suporta alte costuri decât cele de
        retur.
      </p>
      <p>
        Termenul curge din ziua în care ai intrat în posesia produselor.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">2. Cum returnezi un produs</h2>
      <ol className="list-decimal pl-6 space-y-2">
        <li>
          Anunță-ne pe WhatsApp ({COMPANY.phone}) sau email (
          <a href={`mailto:${COMPANY.email}`} className="text-cyan-600 underline">
            {COMPANY.email}
          </a>
          ) că dorești să returnezi produsul.
        </li>
        <li>
          Ambalează produsul în condiții bune, de preferință în ambalajul
          original.
        </li>
        <li>
          Vei primi adresa unde să trimiți coletul prin curierul ales de tine.
        </li>
        <li>
          După primirea și verificarea produsului, îți returnăm banii în
          maximum 14 zile.
        </li>
      </ol>

      <h2 className="font-heading text-xl font-bold text-slate-900">3. Condiții pentru retur</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>Produsul să fie în stare bună, sigilat (dacă a fost livrat sigilat)</li>
        <li>Să nu prezinte urme de utilizare excesivă</li>
        <li>
          Să fie însoțit de toate accesoriile, cadourile și documentele
          primite
        </li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900">4. Excepții de la dreptul de retur</h2>
      <p>
        Conform OUG 34/2014, art. 16, dreptul de retragere NU se aplică pentru:
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>
          Produse sigilate care nu pot fi returnate din motive de protecție a
          sănătății sau de igienă și care au fost desigilate de consumator
        </li>
        <li>Produse personalizate la cererea clientului</li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900">5. Costurile returului</h2>
      <p>
        Costul de transport al returului este suportat de client, cu excepția
        cazului în care produsul livrat nu este conform comenzii (în acest caz
        toate costurile sunt acoperite de noi).
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">6. Rambursarea sumelor</h2>
      <p>
        Rambursarea se face folosind aceeași metodă de plată folosită la
        achiziție (sau prin transfer bancar, dacă plata a fost cash la curier).
        Banii vor ajunge la tine în maximum 14 zile de la primirea produsului
        returnat.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">7. Contact</h2>
      <p>
        Pentru orice nelămurire legată de retur, sună-ne la {COMPANY.phone} sau
        scrie-ne la{" "}
        <a href={`mailto:${COMPANY.email}`} className="text-cyan-600 underline">
          {COMPANY.email}
        </a>
        .
      </p>
    </LegalLayout>
  );
}
